import { useCollapse } from '@vtex/admin-ui'
import constate from 'constate'
import type { PropsWithChildren } from 'react'

export type CollapsibleProviderProps = {
  /** Uncontrolled: initial open state. Ignored when `visible` is set. */
  defaultVisible?: boolean
  /** Controlled: current open state (e.g. driven by external checkbox). */
  visible?: boolean
}

function useCollapsibleValue({
  defaultVisible = false,
  visible: visibleProp,
}: PropsWithChildren<CollapsibleProviderProps>) {
  const visible = visibleProp !== undefined ? visibleProp : defaultVisible

  return useCollapse({ visible })
}

const [CollapsibleProvider, useCollapsibleContext] = constate(useCollapsibleValue)

export { CollapsibleProvider, useCollapsibleContext }
